import { json } from '../c-mp/fun/json'

const dateFormat = new Intl.DateTimeFormat('hu', { dateStyle: 'long' })

export function formatDate(date: string | undefined) {
	if (!date) return undefined
	try {
		const parts = dateFormat.formatToParts(Date.parse(date))
		const dashCount = (date.match(/-/g) || []).length
		const year = parts.find((it) => it.type === 'year')?.value
		const month = parts.find((it) => it.type === 'month')?.value
		const day = parts.find((it) => it.type === 'day')?.value
		switch (dashCount) {
			case 0:
				return `${year}.`
			case 1:
				return `${year}. ${month}`
			case 2:
				return `${year}. ${month} ${day}.`
			default:
				throw new Error(`[t8b0sb] Invalid dash count: ${dashCount}`)
		}
	} catch (e) {
		console.log(json`[t8b0up] formatDate: ${date}`)
		throw e
	}
}
